var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "11", xl: "10" } },
            [
              !_vm.isUserAdmin
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-8",
                      attrs: { type: "error", outlined: "" },
                    },
                    [
                      _vm._v(
                        " You are not allowed to access creation diagnostics. "
                      ),
                    ]
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mt-8 mb-8",
                      attrs: { loading: _vm.listLoading },
                    },
                    [
                      _c(
                        "template",
                        { slot: "progress" },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              color: "#006c27",
                              indeterminate: "",
                              height: "6",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-title",
                        { staticClass: "grey--text text--darken-2" },
                        [
                          _vm._v(" Creation Diagnostics "),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "#006c27",
                                dark: "",
                                loading: _vm.listLoading,
                              },
                              on: { click: _vm.reload },
                            },
                            [_vm._v(" Reload ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-alert",
                            {
                              staticClass: "mb-5",
                              attrs: {
                                dense: "",
                                outlined: "",
                                type: "info",
                                border: "left",
                                "colored-border": "",
                              },
                            },
                            [
                              _vm._v(
                                " Assessment reads the current CASS, SAP, and Entra resource state and stores a safe snapshot. It does not create, update, or delete external resources. A hold prevents another creation request for the owner until it is released. "
                              ),
                            ]
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "", align: "center" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "7" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label:
                                        "Search operation ID, owner reference, or display name",
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      "hide-details": "",
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.applyFilters.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function ($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "ma-0",
                                    attrs: {
                                      label: "Failed only",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.failedOnly,
                                      callback: function ($$v) {
                                        _vm.failedOnly = $$v
                                      },
                                      expression: "failedOnly",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-end",
                                  attrs: { cols: "12", md: "3" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "#006c27",
                                        dark: "",
                                        loading: _vm.listLoading,
                                      },
                                      on: { click: _vm.applyFilters },
                                    },
                                    [_vm._v(" Search ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        color: "#006c27",
                                        disabled: _vm.listLoading,
                                      },
                                      on: { click: _vm.clearFilters },
                                    },
                                    [_vm._v(" Clear ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-data-table",
                            {
                              staticClass: "elevation-1 mt-5",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.items,
                                loading: _vm.listLoading,
                                "item-key": "operationId",
                                "hide-default-footer": "",
                              },
                              on: { "click:row": _vm.openDetail },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: `item.status`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              small: "",
                                              dark: "",
                                              color: _vm.statusColor(
                                                item.status
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.status || "unknown"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.held`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              small: "",
                                              dark: "",
                                              color: item.held
                                                ? "#ef6c00"
                                                : "#607d8b",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.held ? "active" : "none"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.createdAt`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "text-caption" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDate(item.createdAt)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "no-data" }, [
                                _vm.listLoading
                                  ? _c("div", [_vm._v("Loading operations...")])
                                  : _c("div", [
                                      _vm._v("No creation operations found."),
                                    ]),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-end align-center mt-3",
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    color: "#006c27",
                                    disabled:
                                      !_vm.canGoPrevious || _vm.listLoading,
                                  },
                                  on: { click: _vm.previousPage },
                                },
                                [_vm._v(" Previous ")]
                              ),
                              _c("span", { staticClass: "text-caption mx-3" }, [
                                _vm._v("Page " + _vm._s(_vm.page)),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    color: "#006c27",
                                    disabled:
                                      !_vm.nextCursor || _vm.listLoading,
                                  },
                                  on: { click: _vm.nextPage },
                                },
                                [_vm._v(" Next ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "1100", persistent: "" },
          model: {
            value: _vm.detailDialog,
            callback: function ($$v) {
              _vm.detailDialog = $$v
            },
            expression: "detailDialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { loading: _vm.detailLoading || _vm.actionLoading } },
            [
              _c(
                "v-card-title",
                { staticClass: "text--secondary" },
                [
                  _vm._v(" Creation Operation "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        disabled: _vm.detailLoading || _vm.actionLoading,
                      },
                      on: { click: _vm.closeDetail },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm.detail
                ? _c(
                    "v-card-text",
                    [
                      _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                        _vm._v("Request and Lifecycle"),
                      ]),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Operation ID:")]),
                            _vm._v(" " + _vm._s(_vm.detail.operationId || "-")),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Request ID:")]),
                            _vm._v(" " + _vm._s(_vm.detail.requestId || "-")),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Owner reference:")]),
                            _vm._v(" " + _vm._s(_vm.detail.ownerRef || "-")),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Display name:")]),
                            _vm._v(" " + _vm._s(_vm.detail.displayName || "-")),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Requested environment:")]),
                            _vm._v(
                              " " + _vm._s(_vm.request.environment || "-")
                            ),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [
                              _vm._v("Requested permission model:"),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.request.permissionModel || "-")
                            ),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Status:")]),
                            _vm._v(" " + _vm._s(_vm.detail.status || "-")),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Progress:")]),
                            _vm._v(" " + _vm._s(_vm.detail.progress || "-")),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Attempts:")]),
                            _vm._v(" " + _vm._s(_vm.detail.attempts)),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Creation hold:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.detail.held ? "Active" : "Not active"
                                )
                            ),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Created:")]),
                            _vm._v(
                              " " + _vm._s(_vm.formatDate(_vm.detail.createdAt))
                            ),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Started:")]),
                            _vm._v(
                              " " + _vm._s(_vm.formatDate(_vm.detail.startedAt))
                            ),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Completed:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(_vm.detail.completedAt))
                            ),
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("strong", [_vm._v("Next attempt:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(_vm.detail.nextAttemptAt))
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.detail.failure
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-4",
                              attrs: { dense: "", outlined: "", type: "error" },
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.detail.failure.code ||
                                      "Creation failure"
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.detail.failure.message || "-") +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "mt-5" },
                        [
                          _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                            _vm._v("Progress Messages"),
                          ]),
                          _vm.messages.length === 0
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    type: "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    " No progress messages were recorded. "
                                  ),
                                ]
                              )
                            : _c(
                                "v-simple-table",
                                {
                                  staticClass: "elevation-1",
                                  attrs: { dense: "" },
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Time")]),
                                      _c("th", [_vm._v("Stage")]),
                                      _c("th", [_vm._v("Status")]),
                                      _c("th", [_vm._v("Message")]),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.messages,
                                      function (message, index) {
                                        return _c("tr", { key: index }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(_vm.formatDate(message.at))
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(message.stage || "-")
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(message.status || "-")
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(message.message || "-")
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-5" }),
                      _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                        _vm._v("Resource Checkpoints"),
                      ]),
                      _c(
                        "v-simple-table",
                        { staticClass: "elevation-1", attrs: { dense: "" } },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("CASS application")]),
                              _c("th", [_vm._v("SAP application")]),
                              _c("th", [_vm._v("Entra object ID")]),
                              _c("th", [_vm._v("Entra client ID")]),
                              _c("th", [_vm._v("Service principal ID")]),
                            ]),
                          ]),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.detail.cassApplicationId || "-")
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.detail.sapApplicationId || "-")
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.detail.entraApplicationObjectId || "-"
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.detail.entraApplicationClientId || "-"
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.detail.servicePrincipalId || "-")
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _c("v-divider", { staticClass: "my-5" }),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-2" },
                        [
                          _c("div", { staticClass: "text-subtitle-2" }, [
                            _vm._v("Resource Assessment"),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                color: "#006c27",
                                dark: "",
                                loading: _vm.actionLoading,
                              },
                              on: { click: _vm.assess },
                            },
                            [_vm._v(" Recheck ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "text-caption grey--text mb-3" },
                        [
                          _vm._v(
                            " Recheck only refreshes the recorded assessment. It never changes external resources. "
                          ),
                        ]
                      ),
                      !_vm.detail.assessment
                        ? _c(
                            "v-alert",
                            {
                              attrs: { dense: "", outlined: "", type: "info" },
                            },
                            [
                              _vm._v(
                                " No resource assessment has been recorded yet. Use Recheck to collect a safe current-state snapshot. "
                              ),
                            ]
                          )
                        : [
                            _c(
                              "v-alert",
                              {
                                staticClass: "mb-3",
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  type: "info",
                                },
                              },
                              [
                                _c("strong", [_vm._v("Policy:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.detail.assessment.policy || "-"
                                    ) +
                                    ". " +
                                    _vm._s(_vm.assessmentPolicyExplanation) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "text-caption grey--text mb-2" },
                              [
                                _vm._v(
                                  " Assessed " +
                                    _vm._s(
                                      _vm.formatDate(_vm.detail.assessment.at)
                                    ) +
                                    ". "
                                ),
                              ]
                            ),
                            _c(
                              "v-simple-table",
                              {
                                staticClass: "elevation-1",
                                attrs: { dense: "" },
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Resource")]),
                                    _c("th", [_vm._v("State")]),
                                    _c("th", [_vm._v("Identifier")]),
                                    _c("th", [_vm._v("Client ID")]),
                                    _c("th", [_vm._v("Review")]),
                                    _c("th", [_vm._v("Detail")]),
                                  ]),
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.resources, function (resource) {
                                    return _c("tr", { key: resource.name }, [
                                      _c("td", [_vm._v(_vm._s(resource.name))]),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                small: "",
                                                dark: "",
                                                color: _vm.resourceColor(
                                                  resource.value.state
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.resourceStateText(
                                                      resource.value.state
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            resource.value.id ||
                                              _vm.checkpointFor(resource.key) ||
                                              "-"
                                          )
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            resource.value.clientId ||
                                              (resource.key ===
                                              "entraApplication"
                                                ? _vm.detail
                                                    .entraApplicationClientId
                                                : "-") ||
                                              "-"
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        [
                                          _vm.developerPortalLink(resource)
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    text: "",
                                                    color: "#006c27",
                                                    href: _vm.developerPortalLink(
                                                      resource
                                                    ),
                                                    target: "_blank",
                                                  },
                                                },
                                                [_vm._v(" SAP Portal ")]
                                              )
                                            : _vm._e(),
                                          _vm.azurePortalLink(resource)
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    text: "",
                                                    color: "#006c27",
                                                    href: _vm.azurePortalLink(
                                                      resource
                                                    ),
                                                    target: "_blank",
                                                  },
                                                },
                                                [_vm._v(" Azure Portal ")]
                                              )
                                            : _vm._e(),
                                          !_vm.developerPortalLink(resource) &&
                                          !_vm.azurePortalLink(resource)
                                            ? _c("span", [_vm._v("-")])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "td",
                                        { staticClass: "text-caption" },
                                        [
                                          _vm._v(
                                            _vm._s(resource.value.detail || "-")
                                          ),
                                        ]
                                      ),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ],
                      _c("v-divider", { staticClass: "my-5" }),
                      _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                        _vm._v("Hold Management"),
                      ]),
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            dense: "",
                            outlined: "",
                            type: "warning",
                            border: "left",
                            "colored-border": "",
                          },
                        },
                        [
                          _vm._v(
                            " Releasing a hold only allows the owner to make another creation request. It does not delete or modify SAP, Entra, CASS, or any other external resource. "
                          ),
                        ]
                      ),
                      _vm.detail.held
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "#ef6c00",
                                dark: "",
                                disabled: _vm.actionLoading,
                              },
                              on: { click: _vm.openReleaseDialog },
                            },
                            [_vm._v(" Release Hold ")]
                          )
                        : _c(
                            "div",
                            { staticClass: "text-caption grey--text" },
                            [
                              _vm._v(
                                " No active hold. This record can be permanently deleted if it is no longer needed. "
                              ),
                            ]
                          ),
                      _c("v-divider", { staticClass: "my-5" }),
                      _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                        _vm._v("Audit History"),
                      ]),
                      _vm.audits.length === 0
                        ? _c(
                            "v-alert",
                            {
                              attrs: { dense: "", outlined: "", type: "info" },
                            },
                            [_vm._v("No audit records found.")]
                          )
                        : _c(
                            "v-simple-table",
                            {
                              staticClass: "elevation-1 mb-3",
                              attrs: { dense: "" },
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Time")]),
                                  _c("th", [_vm._v("Action")]),
                                  _c("th", [_vm._v("Actor")]),
                                  _c("th", [_vm._v("Result")]),
                                  _c("th", [_vm._v("Reason")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.audits, function (audit, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.formatDate(audit.at))),
                                    ]),
                                    _c("td", [
                                      _vm._v(_vm._s(audit.action || "-")),
                                    ]),
                                    _c("td", [
                                      _vm._v(_vm._s(audit.actor || "-")),
                                    ]),
                                    _c("td", [
                                      _vm._v(_vm._s(audit.result || "-")),
                                    ]),
                                    _c("td", [
                                      _vm._v(_vm._s(audit.reason || "-")),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          ),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mt-4" },
                        [
                          _c("div", { staticClass: "text-subtitle-2" }, [
                            _vm._v("Safe Diagnostics"),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", small: "", color: "#006c27" },
                              on: {
                                click: function ($event) {
                                  _vm.showRaw = !_vm.showRaw
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.showRaw ? "Hide" : "Show") +
                                  " raw safe diagnostics "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.showRaw
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "text-caption grey--text mb-1" },
                              [
                                _vm._v(
                                  " The backend redacts sensitive values before returning these records. "
                                ),
                              ]
                            ),
                            _c("pre", { staticClass: "detail-json" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.safeJson(_vm.detail.diagnostics || [])
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "v-card-actions",
                [
                  _vm.detail && !_vm.detail.held
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            color: "#b71c1c",
                            disabled: _vm.actionLoading,
                          },
                          on: { click: _vm.openDeleteDialog },
                        },
                        [_vm._v(" Delete Record ")]
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.actionLoading },
                      on: { click: _vm.closeDetail },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "620" },
          model: {
            value: _vm.releaseDialog,
            callback: function ($$v) {
              _vm.releaseDialog = $$v
            },
            expression: "releaseDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Release Creation Hold"),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    { attrs: { dense: "", outlined: "", type: "warning" } },
                    [
                      _vm._v(
                        " This action only permits another user request. It does not delete or alter external resources. "
                      ),
                    ]
                  ),
                  _c("v-textarea", {
                    attrs: {
                      label: "Optional note",
                      outlined: "",
                      rows: "2",
                      "auto-grow": "",
                    },
                    model: {
                      value: _vm.releaseReason,
                      callback: function ($$v) {
                        _vm.releaseReason = $$v
                      },
                      expression: "releaseReason",
                    },
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      color: "#ef6c00",
                      label:
                        "I understand this releases only the creation hold.",
                    },
                    model: {
                      value: _vm.releaseConfirmed,
                      callback: function ($$v) {
                        _vm.releaseConfirmed = $$v
                      },
                      expression: "releaseConfirmed",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.actionLoading },
                      on: {
                        click: function ($event) {
                          _vm.releaseDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#ef6c00",
                        dark: "",
                        loading: _vm.actionLoading,
                        disabled: !_vm.releaseConfirmed,
                      },
                      on: { click: _vm.release },
                    },
                    [_vm._v(" Release Hold ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "620" },
          model: {
            value: _vm.deleteDialog,
            callback: function ($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Permanently Delete Record"),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    { attrs: { dense: "", outlined: "", type: "error" } },
                    [
                      _vm._v(
                        " This permanently deletes this diagnostics record and its audit history. It cannot be undone and does not delete external resources. "
                      ),
                    ]
                  ),
                  _c("v-checkbox", {
                    attrs: {
                      color: "#b71c1c",
                      label:
                        "I understand this permanent deletion cannot be undone.",
                    },
                    model: {
                      value: _vm.deleteConfirmed,
                      callback: function ($$v) {
                        _vm.deleteConfirmed = $$v
                      },
                      expression: "deleteConfirmed",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.actionLoading },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#b71c1c",
                        dark: "",
                        loading: _vm.actionLoading,
                        disabled: !_vm.deleteConfirmed,
                      },
                      on: { click: _vm.remove },
                    },
                    [_vm._v(" Delete Permanently ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbar.color, timeout: "4000" },
          model: {
            value: _vm.snackbar.visible,
            callback: function ($$v) {
              _vm.$set(_vm.snackbar, "visible", $$v)
            },
            expression: "snackbar.visible",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }